module.exports = __webpack_public_path__ + "img/prize-03.29d606b0.png";